module.exports = ".footer{position:absolute;bottom:0}"